/**
 * 将对象数组根据指定属性分组为二维数组
 * @param {Object[]} array - 要处理的对象数组
 * @param {string} groupKey - 用于分组的属性名
 * @param {Object} [options] - 配置选项
 * @param {string} [options.sort='none'] - 排序方式: 'none', 'asc' (升序), 'desc' (降序)
 * @param {string} [options.format='array'] - 输出格式: 'array' (二维数组), 'arrayWithKey' (带分组键), 'object' (对象)
 * @param {Function} [options.keyTransform] - 对分组键进行转换的函数
 * @returns {Array[]|Object} 分组后的结果（根据format参数决定）
 */

export const  groupBy = (array, groupKey, options = {}) => {
    // 参数验证
    if (!Array.isArray(array)) {
        throw new TypeError('第一个参数必须是数组');
    }
    if (typeof groupKey !== 'string') {
        throw new TypeError('分组键必须是字符串');
    }
    
    // 设置默认选项
    const { 
        sort = 'none', 
        format = 'array', 
        keyTransform = k => k 
    } = options;
    
    // 1. 创建分组映射
    const groupedMap = new Map();
    
    // 2. 遍历数组进行分组
    for (const item of array) {
        // 获取分组键值
        let keyValue = item[groupKey];
        
        // 处理键值为undefined的情况
        if (keyValue === undefined) {
            keyValue = '__undefined__';
        }
        
        // 应用键转换函数
        keyValue = keyTransform(keyValue);
        
        // 创建分组如果不存在
        if (!groupedMap.has(keyValue)) {
            groupedMap.set(keyValue, []);
        }
        
        // 添加当前项到分组
        groupedMap.get(keyValue).push(item);
    }
    
    // 3. 处理排序
    let groups = Array.from(groupedMap);
    
    if (sort !== 'none') {
        groups.sort((a, b) => {
            const aValue = a[0];
            const bValue = b[0];
            
            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return sort === 'asc' ? aValue - bValue : bValue - aValue;
            }
            
            // 字符串比较
            const comparison = String(aValue).localeCompare(String(bValue));
            return sort === 'asc' ? comparison : -comparison;
        });
    }
    
    // 4. 根据输出格式处理结果
    switch (format) {
        case 'array':
            return groups.map(group => group[1]);
            
        case 'arrayWithKey':
            return groups.map(([key, value]) => ({
                key: key === '__undefined__' ? undefined : key,
                values: value
            }));
            
        case 'object':
            return groups.reduce((obj, [key, value]) => {
                obj[key === '__undefined__' ? undefined : key] = value;
                return obj;
            }, {});
            
        default:
            throw new Error(`不支持的输出格式: ${format}`);
    }
};


